const colors = {
  main: "black",
  secondary: "#FD223E",
  light: "white",
};

//#ff722e
export default colors;
